import * as varSopi from '../sopi/variables';

import * as varApi from '../clients/api/variables';
import * as api from '../clients/api';

import * as varAdmin from '../clients/admin/variables';
import * as apiAdmin from '../clients/admin';



import * as varDatentransfer from '../clients/datentransfer/variables';
import * as apiDatentransfer from '../clients/datentransfer';

// import * as varVorlagen from '../../clients/vorlagen/variables';
// import * as varVeranstaltungen from '../../clients/veranstaltungen/variables';
// import * as varVeranstaltungenDp from '../../clients/veranstaltungen-dienstplan/variables';
// import * as varKommunikation from '../../clients/kommunikation/variables';
// import * as varPandemie from '../../clients/pandemie/variables';
// import * as varIncidents from '../../clients/incidents/variables';
// import * as varEinlasskontrolle from '../../clients/einlasskontrolle/variables';
// import * as varDisplaysteuerung from '../../clients/displaysteuerung/variables';
// import * as varQs from '../../clients/qschecks/variables';
//
// import * as apiBenutzerverwaltung from '../../clients/benutzerverwaltung';
// import * as api from '../../clients/api';
// import * as apiVeranstaltungen from '../../clients/veranstaltungen';
// import * as apiVeranstaltungenDp from '../../clients/veranstaltungen-dienstplan';
// import * as apiKommunikation from '../../clients/kommunikation';
// // import * as apiVorlagen from '../../clients/vorlagen';
// import * as apiPandemie from '../../clients/pandemie';
// import * as apiIncidents from '../../clients/incidents';
// import * as apiEinlasskontrolle from '../../clients/einlasskontrolle';
// import * as apiDisplaysteuerung from '../../clients/displaysteuerung';
// import * as apiQs from '../../clients/qschecks';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';

@NgModule({
    imports: [
        HttpClientModule,

        // Clients
        api.ApiModule,
        apiAdmin.ApiModule,
        apiDatentransfer.ApiModule

    ],
    providers: []
})
export class ClientsModule {
    public static forRoot(apiUrl: string): ModuleWithProviders<ClientsModule> {
        return {
            ngModule: ClientsModule,
            providers: [
                {
                    provide: varSopi.BASE_PATH,
                    useValue: apiUrl
                },
                {
                    provide: varApi.BASE_PATH,
                    useValue: apiUrl
                },
                {
                    provide: varAdmin.BASE_PATH,
                    useValue: apiUrl
                },
                {
                    provide: varDatentransfer.BASE_PATH,
                    useValue: apiUrl
                }
            ]
        };
    }
}
